import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiRoutes } from "../models/constants/api-routes";
import { ApiUtils } from "../utils/api-utils";

export interface ServerConfigBackOfficeViewModel {
    cacheUpdateTimeout: number;
}

@Injectable({
    providedIn: "root",
})
export class ApiServerConfigsService {
    private _httpClient = inject(HttpClient);

    public getServerConfigs(): Observable<ServerConfigBackOfficeViewModel> {
        return this._httpClient.get<ServerConfigBackOfficeViewModel>(
            ApiUtils.buildUrl(ApiRoutes.offers.serverConfigs),
        );
    }
}
